import { useState, memo } from 'react'
import { InView } from 'react-intersection-observer'
import { useRouter } from 'next/router'
import cn from 'classnames'
// Components
import Loader from '../../newLoader/Loader'
import Button from '../../newButton/Button'
// Utils
import query from '@/utils/query'
import { statesByCountry } from '@/utils/countries_and_states'
import {
  capitalizeFirstLetterOfTitle,
  slugConverter,
  useMediaQuery,
} from '@utils'
import { GET_VETERINARIANS } from '@graphql'

import styles from './searchInput.module.scss'

export default memo(function SearchInput() {
  const isTablet = useMediaQuery('(max-width:1194px)')

  const [showError, setShowError] = useState(false)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState('')

  const router = useRouter()
  const stateByUS = statesByCountry[0].states
  const stateByCA = statesByCountry[1].states

  const fetchData = async (location) => {
    setLoading(true)
    const { getVeterinarians } = await query({
      query: GET_VETERINARIANS,
      variables: {
        location,
      },
    })
    setLoading(false)

    // if search by name city or state  = EXAMPLE : Alabama / Miami
    if (getVeterinarians && location.length > 2) {
      const nameStateUS = stateByUS.filter(
        (elem) =>
          elem.label === capitalizeFirstLetterOfTitle(location.toLowerCase())
      )
      const nameStateCA = stateByCA.filter(
        (elem) =>
          elem.label === capitalizeFirstLetterOfTitle(location.toLowerCase())
      )

      const state = getVeterinarians[0]?.location.state

      const findCity = getVeterinarians.filter(
        (elem) =>
          elem.location.city ===
          capitalizeFirstLetterOfTitle(location.toLowerCase())
      )
      const city =
        findCity.length > 0
          ? findCity[0]?.location.city
          : capitalizeFirstLetterOfTitle(location.toLowerCase())

      if (nameStateUS.length > 0 || nameStateCA.length > 0) {
        return router.push(
          `find-a-vet/${
            nameStateUS[0]?.value
              ? nameStateUS[0]?.value.toLowerCase()
              : nameStateCA[0]?.value.toLowerCase()
          }`
        )
      }
      // if search city + state = EXAMPLE: orlando, fl / orlando, Florida
      if (location.includes(',')) {
        const array = location.split('')
        const index = array.indexOf(',')
        const city = capitalizeFirstLetterOfTitle(
          array.slice(0, index).join('')
        )
        const state = array
          .slice(index + 1, array.length)
          .join('')
          .trim()
        const nameState = stateByUS.filter(
          (elem) => elem.label === capitalizeFirstLetterOfTitle(state)
        )
          ? stateByUS.filter(
              (elem) => elem.label === capitalizeFirstLetterOfTitle(state)
            )
          : stateByCA.filter(
              (elem) => elem.label === capitalizeFirstLetterOfTitle(state)
            )
        return (nameState || state) && city
          ? router.push(
              `find-a-vet/${
                nameState[0]?.value
                  ? nameState[0].value.toLowerCase()
                  : state.toLowerCase()
              }/${slugConverter(city).toLowerCase()}`
            )
          : handleShowError()
      } else {
        return state && city
          ? router.push(
              `find-a-vet/${state.toLowerCase()}/${slugConverter(city).toLowerCase()}`
            )
          : handleShowError()
      } // if search by state slug. EXAMPLE = ON
    } else if (location.length === 2) {
      const slugState =
        stateByUS?.some((elem) => elem.value === location.toUpperCase()) ||
        stateByCA?.some((elem) => elem.value === location.toUpperCase())
      return slugState
        ? router.push(`find-a-vet/${location.toLowerCase()}`)
        : handleShowError()
    } else {
      handleShowError()
    }
  }

  // HANDLE SHOW ERROR ZIPCODE BANNER
  function handleShowError() {
    setShowError(true)
    setTimeout(() => {
      setShowError(false)
    }, 4000)
  }

  return (
    <>
      <InView
        className={cn({
          [styles.bar]: true,
          [styles['home-unpinned']]: true,
        })}
      >
        {loading && (
          <div className={styles.loader}>
            <Loader theme="tall" />
          </div>
        )}

        <div className={styles.formsContainer}>
          <form
            className={styles.form}
            autoComplete="off"
            onSubmit={(e) => {
              e.preventDefault()
              fetchData(data)
            }}
          >
            <div className={styles.search}>
              <div className={styles.inputContainer}>
                <label htmlFor="query">Location</label>
                <input
                  id="query"
                  type="text"
                  autoComplete="off"
                  value={data}
                  onChange={(e) => {
                    setData(e.target.value)
                  }}
                />
                {data.length === 0 && <span>Town, City or State</span>}
              </div>
            </div>

            <div className={styles.sectionBtn}>
              <Button
                centerImage="/search/search.svg"
                theme={['pink-solid', 'medium']}
                height={isTablet ? 20 : 25}
                width={isTablet ? 20 : 25}
                onClick={() => fetchData(data)}
                altImg="Search icon"
              />
            </div>
          </form>
        </div>
      </InView>
      {showError && (
        <div onClick={() => setShowError(false)} className={styles.errorMess}>
          {' '}
          <img src="/search/alert-circle.svg" alt="alert circle" />
          State or City not found
        </div>
      )}
    </>
  )
})
